import { render, staticRenderFns } from "./PagesForm.vue?vue&type=template&id=0b18cf88"
import script from "./PagesForm.vue?vue&type=script&lang=js"
export * from "./PagesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports